import React from 'react';
import { BaseModal, Button } from '@cokitchen/cokitchen-components';
import { OrderDetailsType, OrderType } from 'models/order.model';
import OrderDetailsUser from './order-details-user';
import { LocationIcon } from 'cokitchen-icons';
import UpdateMealCard from 'components/base/update-meal-card';
import { formatNumber } from 'utils/functions';

type OrderUpdateProps = {
  totalNoOfBrands: number | string;
  totalNoOfItems: number | string;
  order: OrderType;
  closeUpdateModal: () => void;
  isOpen: boolean;
  orderDetails: OrderDetailsType[];
};

export default function OrderUpdateModal({
  closeUpdateModal,
  order,
  totalNoOfBrands,
  totalNoOfItems,
  isOpen,
  orderDetails
}: OrderUpdateProps) {
  const subTotal = formatNumber(order?.calculated_order.total_amount);
  return (
    <BaseModal
      isOpen={isOpen}
      onRequestClose={closeUpdateModal}
      position='left'
      size='full-width'
      title=''>
      <div className='flex flex-col md:flex-row h-full border-t border-l border-[#DCE2EA]'>
        <main className='basis-4/6 pt-6 overflow-auto'>
          <div className='px-4'>
            <OrderDetailsUser order={order} />
          </div>

          <div className='mt-6 border-t p-4 border-[#DCE2EA] overflow-auto'>
            <div className='flex gap-2 overflow-x-auto '>
              {[].map((brand: any) => (
                <div key={brand.value}>
                  {' '}
                  <button className=' bg-gray-11  text-gray-5 border text-nowrap border-[#EAECEC] rounded-[40px] p-2'>
                    {brand.text}
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div className='grid grid-cols-3 px-4 gap-4 '>
            <button className='border border-[#EAEBEB]  p-4 rounded-md'>
              <h3 className='font-medium text-[#1A1A1A] '>Naija special fried rice</h3>
              <p className='text-xs text-[#858585'>1500</p>
            </button>
          </div>
        </main>

        {/* Second half */}

        <section className='bg-[#F7F7F7] p-2 max-h-full overflow-y-auto flex flex-col gap-2  basis-2/6 '>
          <div className='p-4 bg-white'>
            <div className='flex justify-between items-center '>
              <h6 className='font-medium text-base text-[#1A1A1A]'>Basket</h6>
              <button className='text-xs'>Undo changes</button>
            </div>
            <p className='text-xs text-gray-8'>
              {totalNoOfBrands} brands, {totalNoOfItems} items
            </p>
            <div className='mt-6 flex items-center gap-2'>
              <LocationIcon color='gray' />{' '}
              <p className='truncate text-sm text-[#595959]'>
                {order.calculated_order.address_details.address_line}
              </p>
            </div>
          </div>
          {/* Meals details */}
          <div className='flex flex-col gap-2'>
            {orderDetails.map((order) => (
              <UpdateMealCard key={order.id} order={order} />
            ))}
          </div>

          <div>
            <div className='flex justify-between font-medium bg-white py-6 px-4 text-[#1A1A1A] mb-12'>
              <h3>SubTotal</h3>
              <p>{subTotal}</p>
            </div>
          </div>
          <div className='flex gap-2 p-4 bg-white'>
            {' '}
            <Button
              className='text-3 md:text-sm grow w-full md:max-w-[270px]  lg:max-w-[500px]'
              color='gray'
              variant='block'>
              Cancel
            </Button>
            <Button
              className='text-3 md:text-sm grow w-full md:max-w-[270px]  lg:max-w-[500px]'
              color='primary'
              variant='block'>
              Confirm Order
            </Button>
          </div>
        </section>
      </div>
    </BaseModal>
  );
}
